import { API_REQUEST } from '../middlewares/authMiddleware.js';
import { replace } from 'react-router-redux';

export const SELECTION_FETCHED = Symbol('SELECTION_FETCHED');
export const SELECTION_DETAIL_FETCHED = Symbol('SELECTION_DETAIL_FETCHED');
export const SELECTION_PHOTOS_FETCHED = Symbol('SELECTION_PHOTOS_FETCHED');
export const SELECTION_FETCHED_ERROR = Symbol('SELECTION_FETCHED');

export function backToHome() {
  return replace('/');
}

export function backToTypeSelection() {
  return replace('/selections');
}

export function fetchSelections() {
  return dispatch => {
    dispatch({
      [API_REQUEST]: {
        types: [
          SELECTION_FETCHED,
          SELECTION_FETCHED_ERROR,
        ],
        entrypoint: '/hearing-aids',
        method: 'GET',
        auth: false,
      },
    });
  };
}

export function fetchSelectionDetail(typeId) {
  return {
    [API_REQUEST]: {
      types: [
        SELECTION_DETAIL_FETCHED,
      ],
      entrypoint: `/hearing-aids/${typeId}`,
      method: 'GET',
      auth: false,
    },
  };
}

export function fetchSelectionPhotos(typeId, characterId, colorId, firmId) {
  return {
    [API_REQUEST]: {
      types: [
        SELECTION_PHOTOS_FETCHED,
      ],
      entrypoint: `/hearing-aids/${typeId}/firms/${firmId}/colors/${colorId}/characters/${characterId}/photos`,
      method: 'GET',
      auth: false,
    },
  };
}



// WEBPACK FOOTER //
// ./actions/Selection.js